export * from './IconHomeDollar';
export { default as IconHomeDollar } from './IconHomeDollar';
